import { FC } from "react";
import { createMarkup } from "../utils/Helpers";

type Props = {
    body: string
}

export const Reply: FC<Props> = (props: Props) => (
    <blockquote className="mb-2" dangerouslySetInnerHTML={createMarkup(props.body)}></blockquote>
);